import getSearches from './getSearches'
import exportSearches from './exportSearches'
import updateStatusSearch from './updateStatusSearch'
import getBusqHistOC from './getBusqHistOC'
import saveCommentOC from './saveCommentOC'

export const getSearchesPromise = getSearches
export const exportSearchesPromise = exportSearches
export const updateStatusSearchPromise = updateStatusSearch
export const getBusqHistOCPromise = getBusqHistOC
export const saveCommentOCPromise = saveCommentOC
